// PasswordField.tsx
import React from "react";
import { useFormContext } from "react-hook-form";
import InputField from "./InputField"; // ← apna existing InputField import karo

interface PasswordFieldProps {
  name?: string;                    // optional, default "password" ya "confirmPassword"
  label?: string;
  placeholder?: string;
  required?: boolean;
  requiredMessage?: string;
  isConfirmPassword?: boolean;      // ← yeh naya prop
  className?: string;
  disabled?: boolean;
  allowSpecialChars?: boolean;
  // agar aur kuch extra chahiye to yahan add kar sakte ho
}

const PasswordField: React.FC<PasswordFieldProps> = ({
  name,
  label = "Password",
  placeholder = "Enter your password",
  required = true,
  requiredMessage = "This field is required",
  isConfirmPassword = false,
  className = "",
  disabled = false,
  allowSpecialChars = true,
  ...rest
}) => {
  const { watch } = useFormContext();
  const passwordValue = watch("password"); // "password" field ka live value

  const defaultName = isConfirmPassword ? "confirmPassword" : "password";
  const finalName = name || defaultName;

  const finalLabel = isConfirmPassword
    ? "Confirm Password"
    : label;

  const finalPlaceholder = isConfirmPassword
    ? "Re-enter your password"
    : placeholder;

  const finalRequiredMessage = isConfirmPassword
    ? "Please confirm your password"
    : requiredMessage;

  return (
    <InputField
      name={finalName}
      label={finalLabel}
      type="password"
      placeholder={finalPlaceholder}
      required={required}
      requiredMessage={finalRequiredMessage}
      allowSpecialChars={allowSpecialChars}
      className={className}
      disabled={disabled}
      validation={{
        // Common password rules (sirf main password ke liye)
        ...(isConfirmPassword
          ? {}
          : {
              minLength: {
                value: 8,
                message: "Password must be at least 8 characters long",
              },
              validate: (val: string) => {
                if (!/[a-z]/.test(val))
                  return "At least one lowercase letter required";
                if (!/[A-Z]/.test(val))
                  return "At least one uppercase letter required";
                if (!/[0-9]/.test(val)) return "At least one number required";
                if (!/[!@#$%^&*(),.?":{}|<>]/.test(val))
                  return "At least one special character required";
                return true;
              },
            }),

        // Confirm password → match validation
        ...(isConfirmPassword
          ? {
              validate: (value: string) =>
                value === passwordValue || "Passwords do not match",
            }
          : {}),
      }}
      {...rest}
    />
  );
};

export default PasswordField;